import { PromotionalDiscount } from '~/components/Common/Forms/RatePlanForm/types';

function toNullable(value: unknown): number | null {
  if (value == null || value === '') {
    return null;
  }
  const num = Number(value);
  return isNaN(num) ? null : num;
}

export function prepareScheduledDiscountList(discounts: Record<string, PromotionalDiscount> | undefined) {
  if (!discounts) {
    return [];
  }

  return Object.values(discounts).map((discount) => ({
    id: discount.id,
    rate_plan_id: discount.rate_plan_id,
    discount_type: discount.discount_type,
    discount_percent: Number(discount.discount_percent) || 0,
    min_los: toNullable(discount.min_los),
    max_los: toNullable(discount.max_los),
    min_days_to_arrival: toNullable(discount.min_days_to_arrival),
    max_days_to_arrival: toNullable(discount.max_days_to_arrival),
    discount_name: discount.discount_name || null,
    is_displayed: discount.is_displayed,
    source: discount.source,
    paid_by: discount.paid_by,
    luxplus_discount_percent: toNullable(discount.luxplus_discount_percent),
    schedules: [
      {
        id: discount.schedules[0].id,
        parent: discount.schedules[0].parent,
        activePeriod: {
          from: discount.schedules[0].activePeriod.from,
          to: discount.schedules[0].activePeriod.to,
        },
        travelPeriod: {
          from: discount.schedules[0].travelPeriod.from,
          to: discount.schedules[0].travelPeriod.to,
        },
        type: discount.schedules[0].type,
      },
    ],
  }));
}
